import { Component, OnInit ,ElementRef,Inject} from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-coordinates',
  templateUrl: './coordinates.component.html',
  styleUrls: ['./coordinates.component.scss']
})
export class CoordinatesComponent implements OnInit {
  editdata: any;

  constructor(@Inject(MAT_DIALOG_DATA) private data:any,public dialog: MatDialog,private dialogRef: MatDialogRef<CoordinatesComponent>) { }

  ngOnInit(): void {
    this.editdata=this.data;
  }

}
